import { sdkRequest } from '@eventbrite/http';
import { useQuery } from 'react-query';

const FIVE_MINUTES = 5 * 60 * 1000;
const ONLINE_PLACE = 'online';

export const useGetPlacesForCollection = (
    collectionId,
    isOnline,
    isInViewport,
) => {
    const response = useQuery(
        ['places_for_collection', collectionId, isOnline],
        async () => {
            const response = await sdkRequest(
                `/api/v3/destination/collections/${collectionId}/places/`,
            );
            const places = response.places.map((place) => place.id);

            return places.length ? places : ONLINE_PLACE;
        },
        {
            enabled: isInViewport,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false,
            staleTime: FIVE_MINUTES,
        },
    );

    if (response.isError) return ONLINE_PLACE;

    return isOnline ? ONLINE_PLACE : response.data;
};
